import { useApolloClient } from "@apollo/client";
import { GET_STAND_TYPES_GROUP } from "graphql/query/stand-gql";
import { GET_ME } from "graphql/query/user-gql";
import Stand from "components/stand";
import { useBreadCrumbs } from "components/use-hooks";
import Localize, { localizeByKey } from "components/service/localize";
import { UploadMedia } from "components/layout";
import type { TStand } from "components/stand/helpers/stand-types-helper";
import { usePermissionByObject } from "components/permissions";

const standBasePath = Stand.Const.basePath;

interface IStandOverviewSubPageProps
{
  stand: TStand | undefined;
  standTypesGroup: TStand[] | undefined;
  conditionCreate: boolean;
  lang: string;
}

const StandOverviewSubPage: React.FC<IStandOverviewSubPageProps> = ({
  stand,
  standTypesGroup,
  conditionCreate,
  lang,
}) =>
{
  const { hasPermission: hasUpdatePermission } = usePermissionByObject(Stand.Const.permissions.UPDATE);

  const client = useApolloClient();
  const cachedMe = client.readQuery({
    query: GET_ME,
  });

  const defaultLang = cachedMe.me.lang_api;
  const activeLang = lang || defaultLang;

  // const disabledField =
  //   stand?.id !== stand?.group_id ||
  //   (conditionCreate && activeLang !== defaultLang);

  const breadcrumbs = [
    {
      label: localizeByKey("BREADCRUMBS.Label_StandTypes"),
      path: `${standBasePath}`,
    },
    {
      label: stand
        ? stand?.title
        : localizeByKey("BREADCRUMBS.Label_Create"),
      path: stand
        ? `${standBasePath}/edit/${stand?.group_id}/${lang}`
        : `${standBasePath}/create/${lang}`,
    },
  ];

  useBreadCrumbs(breadcrumbs);

  return (
    <>
      <Stand.Fields.Langs
        stand={stand}
        standTypesGroup={standTypesGroup}
        activeLang={activeLang}
        conditionCreate={conditionCreate}
        extraClass="form"
      />

      <div className="row-grid col-lg-2">
        <div className={`col-left ${stand?.id && "col-border-right"} `}>
          <Stand.Forms.Edit
            activeLang={activeLang}
            stand={stand}
            conditionCreate={conditionCreate}
          />
        </div>
        <div className="col-right">
          {stand?.id && (
            <>
              <div className="upload-link-holder" style={{ margin: "0 0 25px" }}>
                <span className="label-text">
                  <Localize>FORMS.Input_Label_Model3d</Localize>
                </span>

                <Stand.Fields.Model3d stand={stand} standTypesGroup={standTypesGroup} disabled={!hasUpdatePermission} />

              </div>
              <UploadMedia
                model="StandType"
                identifier="group_id"
                modelId={stand?.group_id}
                defaultMedia={stand?.getImages}
                query={GET_STAND_TYPES_GROUP}
                disabled={!hasUpdatePermission}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default StandOverviewSubPage;
